<script>
  export default {
    data () {
      return {}
    },
    computed: {},
    mounted () {
    },
    destroyed () {
    },
    methods: {},
    components: {}
  }
</script>

<template>
  <div class="bg-white b-b wrapper-md">
    <div class="row">
      <div class="col-md-3 col-sm-6 col-xs-7">
        <div class="m-t-sm">Administração de Orgão Apreensor</div>
      </div>
      <div class="col-md-9 col-sm-6 col-xs-5">
        <ul class="nav nav-pills nav-sm">
          <router-link :to="{name: 'config.bem-equipamento.list'}" tag="li" exact><a href="">Lista</a></router-link>
          <router-link :to="{name: 'config.bem-equipamento.novo'}" tag="li" exact><a href="">Cadastro</a></router-link>
        </ul>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// Header.vue?c825a83e